import styled from 'styled-components';
import { colors } from '@a0/quantum-web';

export const NavContent = styled.div`
  position: absolute;
  visibility: hidden;
  opacity: 0;
  top: ${({ extraSpacing }) => (extraSpacing ? '11.3rem' : '6.4rem')};
  right: 0;
  left: 0;
  max-width: 93.2rem;
  margin: 0 auto;
  padding-top: 1.6rem;
  transform: translateX(-1.6rem);
  transition: visibility 0s, opacity 0.2s linear, transform 0.2s linear;
`;

export const NavItemTitle = styled.div`
  cursor: default;
  position: relative;
  display: block;
  transition: all 0.2s ease-in-out;
  :after {
    content: '';
    transition: background-color 0.2s ease, transform 0.2s ease;
    width: 100%;
    border-radius: 0.2rem 0.2rem 0 0;
    height: 0.3rem;
    background-color: transparent;
    display: block;
    bottom: -2.1rem;
    position: absolute;
    left: 0;
    transform: scale(0, 1);
  }
`;

export const NavItem = styled.li`
  padding: 2.1rem 0;

  p {
    color: white;
    font-weight: 400;

    svg {
      margin-left: 0.4rem;
    }
  }

  :hover,
  :focus-visible,
  :focus-within {
    ${NavItemTitle}:after {
      background-color: #908bff;
      transform: scale(1, 1);
    }
    ${NavItemTitle} p {
      color: #908bff;
    }
    ${NavItemTitle} svg path {
      stroke: #908bff;
    }
    ${NavContent} {
      visibility: visible;
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

export const DesktopWrapper = styled.nav`
  display: none;
  min-height: 6.4rem;
  li,
  a {
    :focus-visible,
    :focus-within,
    :focus {
      outline-color: ${colors.indigo_i75};
    }
  }

  ${({ dark }) =>
    dark &&
    `
    border-bottom: 0.1rem solid rgba(255, 255, 255, 0.2);
  `}

  ${({ theme }) => theme.quantum.media.tablet`
    max-width: 121.6rem;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 2.4rem;
  `}

  ${({ theme }) => theme.quantum.media.desktop`
    padding: 0;
  `}
`;

export const LogoContainer = styled.a`
  grid-column: 1 / 3;
`;

export const Menu = styled.ul`
  display: flex;
  grid-column: 6 / 13;
  padding: 0;
  align-items: center;
  margin: -0.5rem 0;
  list-style-type: none;
  column-gap: 3.2rem;
  justify-self: flex-end;

  ${({ theme }) => theme.quantum.media.desktop`
    column-gap: 4rem;
    padding: 0.5rem 0;
  `}
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  column-gap: 1.6rem;
  margin-left: 0.8rem;

  ${({ theme }) => theme.quantum.media.desktop`
    margin: 0;
  `}
`;
